import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
const contentImg = '/images/content-img.png';

const About = () => {
  return (
    <Layout>
      <section id="greenorange-dest">
        <section className="banner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h1 className="mar0">About Green Orange</h1>
                <p className="colorWht">
                  Transport Management System TMS, GPS Tracking Software and Payroll Management
                  Software Company based in Coimbatore India
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="content-dest">
          <div className="col-lg-12 content-dest-bg">
            <div className="col-lg-5 col-md-5 col-sm-6 padTB58 text-right">
              <img src={contentImg} alt="product" className="content-img" />
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6 padTB58 padLR15">
              <p>
                GreenOrange Private Limited is a global software product, information technology,
                consulting and outsourcing company.
              </p>
              <p>
                GreenOrange helps customers do business better by leveraging our industry-wide
                experience, deep technology expertise, comprehensive portfolio of services and
                vertically aligned business model.
              </p>
              <p>
                In today's world, organizations will have to rapidly reengineer themselves and be
                more responsive to changing customer needs. GreenOrange is well positioned to be a
                partner and co-innovator to businesses in their transformation journey, identify
                new growth opportunities and facilitate their foray into new sectors and markets.
              </p>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 bgwhite">
              <div className="dest-rightside aboutus">
                <div>
                  You may also be interested in <span> our products</span>
                </div>
                <ul className="pad0">
                  <li>
                    <Link to="/transport-management-system" title="Transport Management System">
                      Transport Management System
                    </Link>
                  </li>
                  <li>
                    <Link to="/payroll" title="Payroll Management System">
                      Payroll Management System
                    </Link>
                  </li>
                  <li>
                    <Link to="/gps-tracking-software" title="GPS Tracking as Software">
                      GPS Tracking as Software
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <div className="clearfix"></div>
        <section className="content-dest1">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6">
                <h2>Spirit of GreenOrange</h2>
                <ul>
                  <li>Make customer business successful</li>
                  <li>Innovate, Build, Excel</li>
                  <li>Respect for every individual</li>
                  <li>Be thoughtful and responsible</li>
                  <li>Deliver commitments</li>
                  <li>Be fair and honest in every action</li>
                </ul>
                <h2>Key Differentiators</h2>
                <ul>
                  <li>Create new products and services</li>
                  <li>Reach new markets</li>
                  <li>Quantum shifts in operational efficiencies</li>
                  <li>Enhance user experience</li>
                </ul>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6">
                <h2>Specialized Competencies</h2>
                <ul>
                  <li>Machine Learning</li>
                  <li>Cognitive System</li>
                  <li>Deep Learning</li>
                  <li>User Experience Design</li>
                  <li>Common Sense Reasoning</li>
                  <li>Rapid Prototyping</li>
                  <li>Dialogue Based Interfaces</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </section>
    </Layout>
  );
};

export default About;

